"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getYearIndexFromRange = exports.createSrcRange = exports.monthNames = void 0;
var types_1 = require("./types");
exports.monthNames = [
    'jan',
    'feb',
    'mar',
    'apr',
    'may',
    'jun',
    'jul',
    'aug',
    'sep',
    'oct',
    'nov',
    'dec'
];
var checkIsDisabled = function (incId, year, srcRange) {
    var from = srcRange.from, to = srcRange.to;
    if (year === srcRange.from.year) {
        return incId < from.month ? true : false;
    }
    if (year === to.year) {
        return incId > to.month ? true : false;
    }
    return false;
};
var checkIsSelected = function (year, month, selectedRange) {
    if (year === selectedRange.year && month === selectedRange.month) {
        return true;
    }
    return false;
};
var checkIsSelectable = function (year, incId, selectedRange, selectedLimit, selectDirection) {
    var runForwardsLogic = function () {
        if (year < selectedRange.year || year > selectedLimit.year) {
            return false;
        }
        if ((year === selectedRange.year && incId < selectedRange.monthNumber) ||
            (year === selectedLimit.year && incId > selectedLimit.monthNumber)) {
            return false;
        }
        return true;
    };
    var runBackwardsLogic = function () {
        if (year > selectedRange.year || year < selectedLimit.year) {
            return false;
        }
        if ((year === selectedRange.year && incId > selectedRange.monthNumber) ||
            (year === selectedLimit.year && incId < selectedLimit.monthNumber)) {
            return false;
        }
        return true;
    };
    if (selectDirection === types_1.FROM) {
        return runForwardsLogic();
    }
    else {
        return runBackwardsLogic();
    }
};
var srcMonthsObject = function (year, srcRange, selectedRange, selectedLimit, selectDirection) {
    return exports.monthNames.map(function (month, monthNumber) {
        // special case to increment the id by + 1 allowing month 1 to be January
        var incId = monthNumber + 1;
        return {
            isDisabled: checkIsDisabled(incId, year, srcRange),
            isSelectable: checkIsSelectable(year, incId, selectedRange, selectedLimit, selectDirection),
            isSelected: checkIsSelected(year, month, selectedRange),
            month: month,
            monthNumber: incId,
            year: year
        };
    });
};
exports.createSrcRange = function (srcRange, selectedRange, selectedLimit, selectDirection) {
    var from = srcRange.from, to = srcRange.to;
    return Array(to.year - from.year + 1)
        .fill(from.year)
        .map(function (year, i) { return year + i; })
        .reduce(function (newYears, year) {
        var _a;
        newYears[year] = [];
        (_a = newYears[year]).push.apply(_a, __spread(srcMonthsObject(year, srcRange, selectedRange, selectedLimit, selectDirection)));
        return newYears;
    }, {});
};
exports.getYearIndexFromRange = function (completeRange, selectedYear) {
    return Object.keys(completeRange).indexOf(selectedYear.toString());
};
//# sourceMappingURL=utils.js.map